import { render, staticRenderFns } from "./SuggestAnalysisSampleCard.vue?vue&type=template&id=79649819&scoped=true"
import script from "./SuggestAnalysisSampleCard.vue?vue&type=script&lang=js"
export * from "./SuggestAnalysisSampleCard.vue?vue&type=script&lang=js"
import style0 from "./SuggestAnalysisSampleCard.vue?vue&type=style&index=0&id=79649819&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79649819",
  null
  
)

export default component.exports